import classNames from "classnames";

import './Panel.scss';

const Panel = ({ children }) => {
    return (
        <div
            id="panel"
            className={classNames({'visible': children != null})}
        >
            {children}
          </div>
    );
};

export default Panel;